'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: flex-end;\n  bottom: 0px;\n  right: 0px;\n  width: 15px;\n  height: 15px;\n  max-height: 15px;\n  background-color: #4267b2;\n  padding-right: 3px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: flex-end;\n  bottom: 0px;\n  right: 0px;\n  width: 15px;\n  height: 15px;\n  max-height: 15px;\n  background-color: #4267b2;\n  padding-right: 3px;\n']),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(['\n  width: 6px;\n  height: 12px;\n'], ['\n  width: 6px;\n  height: 12px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _View = require('../View');

var _View2 = _interopRequireDefault(_View);

var _Svg = require('../Svg');

var _Svg2 = _interopRequireDefault(_Svg);

var _facebook = require('../../../assets/icons/facebook');

var _facebook2 = _interopRequireDefault(_facebook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FacebookIcon = (0, _styledComponents2.default)(_View2.default)(_templateObject);

var Logo = (0, _styledComponents2.default)(_Svg2.default)(_templateObject2);

var FBLogo = function FBLogo() {
  return _react2.default.createElement(Logo, { color: '#FFFFFF', width: 6.2, height: 12, viewBox: '0 0 12 24', svgPath: _facebook2.default });
};

var facebookSquare = function facebookSquare() {
  return _react2.default.createElement(
    FacebookIcon,
    null,
    _react2.default.createElement(FBLogo, null)
  );
};

exports.default = facebookSquare;